/* src/app/components/order-content-modal/order-content-modal.component.scss */
.wrapper {
  height: 100%;
}
/*# sourceMappingURL=order-content-modal.component.css.map */
